import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { PostCenterSignUpRequest } from '../type/types';

interface postCenterSignUpProps {
  loginId: string; // 로그인 ID
}

/** 관리자: 센터 회원가입 */
export const postCenterSignUp = async (data: PostCenterSignUpRequest) => {
  const res = await api.post<ApiResponseType<postCenterSignUpProps>>(
    '/api/web/admins/partners/centers',
    data
  );
  return res.data;
};
